<script lang="ts" setup>
import { computed, type PropType } from 'vue';

const props = defineProps({
  item: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({}),
  },

  descriptionList: {
    type: Array as PropType<Record<string, any>[]>,
    default: () => [],
  },
});

const defaultProjectBg = 'https://res.oafimg.cn/-/a8ee53c6c404982d/XuperCore.png';

const getTruncateClass = (item: Record<string, any>) => {
  if (item.projectCode && item.externalLink) {
    return 'max-w-70%';
  }

  if (item.projectCode || item.externalLink) {
    return 'max-w-80%';
  }

  return 'max-w-100%';
};

const cardImage = computed(() => {
  return props.item.cardSidebar || defaultProjectBg;
});
</script>

<template>
  <div
    class="group h-356 w-432 border border-[rgba(154,158,166,0.1)] rounded-4 border-solid bg-white shadow-[0_0_16px_0_rgba(0,0,0,0.04)] duration-200 ease-linear transition-property-all <2xl:w-384 <md:h-auto <md:w-full hover:translate-y--12"
  >
    <template v-if="props.item.id">
      <img :data-src="cardImage" class="lazyload h-88px w-100% object-cover">

      <div class="p-32px pt-16px <md:p-16px <md:pt-12px">
        <div class="h-36 flex-y-center text-24 text-#2d2d2d <md:h-auto <md:flex-wrap <md:items-start">
          <span
            class="mb-4 inline-block h-36 truncate text-24 text-#2d2d2d font-medium leading-36 <md:mb-0 <md:h-auto <md:max-w-full <md:whitespace-normal <md:text-20 <md:leading-30 <2xl:max-w-60%"
            :class="getTruncateClass(props.item)"
            :title="props.item.title"
          >
            {{ props.item.title }}
          </span>

          <div class="ml-auto flex flex-shrink-0 items-center gap-x-12 <md:ml-0 <md:mt-8 <md:w-full">
            <a
              v-if="props.item.projectCode"
              :href="props.item.projectCode"
              target="_blank"
              class="inline-block h-24 text-14 text-#1180ff leading-24 no-underline"
            >
              {{ $t('projects.index.codeCabin2') }}
            </a>
            <a
              v-if="props.item.externalLink"
              :href="props.item.externalLink"
              target="_blank"
              class="inline-block h-24 text-14 text-#1180ff leading-24 no-underline"
            >
              {{ $t('projects.index.website2') }}
            </a>
          </div>
        </div>

        <div class="h-128 overflow-y-auto <md:h-auto">
          <div
            class="mt-8 flex text-16 text-#2d2d2d leading-24"
            v-show="props.item[piece.content]"
            v-for="piece in props.descriptionList"
            :key="piece.title"
            :title="item[piece.content]"
          >
            <span class="mr-8 flex-shrink-0">{{ piece.title }}:</span>
            <span class="truncate">{{ props.item[piece.content] }}</span>
          </div>
        </div>

        <a
          :href="props.item.projectDownload"
          class="mt-24 inline-block border border-#1180ff rounded-4 border-solid px-20 py-7 text-center text-14 text-#1180ff no-underline <md:w-full group-hover:border-unset group-hover:bg-#1180ff group-hover:text-white"
          target="_blank"
          v-if="props.item.projectDownload"
        >
          {{ $t('projects.index.details2') }}
        </a>
      </div>
    </template>
  </div>
</template>
